import { useMutation } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { BookTimeSlotMutation } from "../../../graphql/deliveryService/mutations/bookTimeSlot";
import { SuccessOutput } from "../../../models/autogenerated-deliveryService-gql/graphql";
import { handleError } from "../../../utils/graphqlHelper";

interface BookTimeSlotMutationProps {
  id: string;
  dataAction: (success: SuccessOutput) => void;
  errorAction?: () => void;
}

const useBookTimeSlotMutation = (props: BookTimeSlotMutationProps) => {
  const { t } = useTranslation();
  const { id, dataAction, errorAction } = props;

  const mutation = useMutation(BookTimeSlotMutation, {
    update: (cache, result) => {
      const data = result.data?.bookTimeSlot.successOutput;
      if (!data) return;

      const cacheId = cache.identify({
        __typename: "InboundDeliveryDetail",
        id,
      });
      cache.evict({ id: cacheId });
      cache.evict({ fieldName: "inboundDeliveries" });
      cache.gc();
    },
  });

  const { data, error } = mutation[1];

  const successOutput = data?.bookTimeSlot.successOutput;

  useEffect(() => {
    if (!error) return;

    handleError(t("bookTimeSlotError"), error.message, errorAction);
  }, [error]);

  useEffect(() => {
    if (!data || !successOutput) return;

    dataAction(successOutput);
  }, [data]);

  return mutation;
};

export default useBookTimeSlotMutation;
